import React from 'react'
import classnames from 'classnames'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import useUser from '../hooks/useUser'
import { Link } from 'react-router-dom'
import { setScrollToOrganizationSelector } from '../store/slices/appSlice'

const Banner = ({ page }) => {
  const location = useLocation()
  const { data: userData } = useUser()
  const dispatch = useDispatch()

  const { showBannerOnStartpage, showSaveLifeAtWork } = useSelector(
    (state) => state.app.appSettings,
  )

  const handleLinkClick = () => {
    dispatch(setScrollToOrganizationSelector(true))
  }

  if (location.pathname === '/' && !showBannerOnStartpage) return null

  if (location.pathname === '/mina-utmarkelser') return null
  if (location.pathname === '/radda-liv-pa-arbetstid') return null

  const companySaved = userData?.organizationId !== undefined && userData?.organizationId !== 0
  return (
    <>
      <div
        className={classnames('banner', { 'is-start': location.pathname === '/' })}
        style={{ backgroundImage: page.headerImage && `url(/images/${page.headerImage})` }}
      >
        {location.pathname === '/' ? (
          <>
            <div className="welcome-bubble">{__.trans('start.welcome')}</div>
            <div className="ready-bubble">
              <span>{__.trans('start.thanks-for-giving')}</span>
            </div>
          </>
        ) : (
          <h2>{page.headerText}</h2>
        )}
      </div>
      {showSaveLifeAtWork && location.pathname === '/' && (
        <div className="save-life-banner">
          {companySaved ? (
            <Link
              tabIndex={0}
              to="/radda-liv-pa-arbetstid"
              onClick={handleLinkClick}
              title={__.trans('start.save-life-at-work-read-more')}
              aria-label={__.trans('start.save-life-at-work-read-more-aria-label')}
            >
              {__.trans('start.save-life-at-work-company-before')} {userData?.organizationText}{' '}
              {__.trans('start.save-life-at-work-company-after')}
            </Link>
          ) : (
            <Link
              tabIndex={0}
              to="/radda-liv-pa-arbetstid"
              onClick={handleLinkClick}
              title={__.trans('start.save-life-at-work-read-more')}
              aria-label={__.trans('start.save-life-at-work-read-more-aria-label')}
            >
              {__.trans('start.save-life-at-work-no-company')}{' '}
            </Link>
          )}
        </div>
      )}
    </>
  )
}

export default Banner
